import { Controller } from "@hotwired/stimulus"

// Mounted alongside the shared `validation` controller on the same form, which owns the
// submit-button gating through its "email" and "required" rules.
//
// The inline "invalid email"/"invalid password" messages are NOT wired through `validation`'s
// message target: their timing differs from its touched-style shape. The email message arms only
// after the field has been typed into (a hand-rolled "dirty" class set by "input", never by blur),
// any refocus clears it regardless of validity, and a later blur without retyping re-arms it since
// "dirty" is never removed. The password message has no such gate and shows on any blur of a blank
// value. Wiring blur->touch here would flag an email field the user merely tabbed past.
//
// So both handlers come straight from window.ltFormValidators instead. The password show/hide
// toggle is unique to this form and lives here too.
export default class extends Controller {
  static get targets() {
    return ["passwordInput", "passwordToggleIcon"];
  }

  connect() {
    window.ltFormValidators.setInvalidEmailHandler($(this.element));
    window.ltFormValidators.setInvalidPasswordHandler($(this.element));
  }

  togglePasswordInput() {
    const passwordInput = this.passwordInputTarget;
    const icon = this.passwordToggleIconTarget;

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      icon.classList.remove("icon-lasso-show");
      icon.classList.add("icon-lasso-hide");
    } else {
      passwordInput.type = "password";
      icon.classList.remove("icon-lasso-hide");
      icon.classList.add("icon-lasso-show");
    }
  }
}
